import Select from './Select';

export default class CompanySelect extends Select {
    prepareInputs(iso) {
        let elGroupIcDph = document.getElementById('input-ic-dph');
        let elGroupIc    = document.getElementById('input-ic');
        let elGroupDic   = document.getElementById('input-dic');

        let elLabelIc    = elGroupIc.getElementsByTagName('label');
        let elInputIc    = elGroupIc.getElementsByTagName('input');
        let elLabelDic   = elGroupDic.getElementsByTagName('label');
        let elInputDic   = elGroupDic.getElementsByTagName('input');

        elGroupIcDph.classList.add('d-none');

        if (iso === 'pl') {
            this.setLabel(elLabelDic, 'NIP');
            this.setPlaceholder(elInputDic, 'NIP');

            this.setLabel(elLabelIc, 'REGON');
            this.setPlaceholder(elInputIc, 'REGON');
        }

        if (iso === 'sk') {
            this.setLabel(elLabelDic, 'DIČ');
            this.setPlaceholder(elInputDic, 'DIČ');

            this.setLabel(elLabelIc, 'IČ');
            this.setPlaceholder(elInputIc, 'IČ');

            elGroupIcDph.classList.remove('d-none');
        }

        if (iso === 'cs') {
            this.setLabel(elLabelDic, 'DIČ');
            this.setPlaceholder(elInputDic, 'DIČ');

            this.setLabel(elLabelIc, 'IČ');
            this.setPlaceholder(elInputIc, 'IČ');
        }
    }

    setLabel(elem, label) {
        if (elem[0]) {
            elem[0].innerText = label;
        }
    }

    setPlaceholder(elem, placeholder) {
        if (elem[0]) {
            elem[0].placeholder = placeholder;
        }
    }

    flagHandler(iso) {
        super.flagHandler(iso);
        this.prepareInputs(iso);
    }
}
